import { CommentModel } from "../core/models/Comment";



interface CommentTitleProps {
    comment: CommentModel,
    visible: boolean
}

const CommentTile: React.FC<CommentTitleProps> = ({ comment, visible }) => {
    return <div style={{
        borderWidth: 1,
        borderColor: "#d2d2d2",
        borderStyle: "solid",
        margin: 2,
        padding: 2,
        marginBottom: 8,
        borderRadius: 4,
        opacity: visible? 1: .5,
    }}>
        <div style={{
            display: "flex",
            alignItems: "center"
        }}>
            <img src={comment.userphoto} style={{ height: 32, width: 32 }} alt={`${comment.username}'s profile`} />
            <h5 style={{margin: 0}}>{comment.username}</h5>
        </div>
        <p>{comment.text}</p>
    </div>
}

export default CommentTile;